import { AuthResponse } from '../models/user.model';
import { Injectable } from '@angular/core';
import { User } from '../models/user.model';
import { Observable } from 'rxjs';
import { ApolloService } from './apollo.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private apolloService: ApolloService) {}

  login(user: User): Observable<AuthResponse> {
    return this.apolloService.query(
      `{login(user: {username: "${user.username}", password:"${user.password}"}){token}}`,
      'login'
    );
  }
}
